export const images: string[] = [
  "http://eventena.in/assets/images/CarosualImg1.jpg",
  "http://eventena.in/assets/images/CarosualImg2.jpg",
  "http://eventena.in/assets/images/CarosualImg3.jpg",
  "http://eventena.in/assets/images/CarosualImg4.jpg",
  "http://eventena.in/assets/images/CarosualImg5.jpg",
  "http://eventena.in/assets/images/CarosualImg6.jpg",
  "http://eventena.in/assets/images/CarosualImg7.jpg",
  "https://devminds.co.in/assets/img/eventena/event5.jpg",
  "https://devminds.co.in/assets/img/eventena/event6.jpg",
  "https://devminds.co.in/assets/img/eventena/event7.jpg",
  "https://devminds.co.in/assets/img/eventena/event8.jpg",
  "https://devminds.co.in/assets/img/eventena/event9.jpg",
  "https://devminds.co.in/assets/img/eventena/event10.jpg",
  "https://devminds.co.in/assets/img/eventena/event11.jpg",
  "https://devminds.co.in/assets/img/eventena/event12.jpg",
  "https://devminds.co.in/assets/img/eventena/event13.jpg",
  "https://devminds.co.in/assets/img/eventena/event14.jpg"
];
